import React from "react";
import { Button, message, Menu, Dropdown } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useSaleRoModel } from "../saleRoModel";
import { globalPrompt } from "@/components/message";
import useNavModel from "@/model/navModel";
import { useSaleRoDetailModel, IMaterialDetailModel } from "./details/saleRoDetailModel";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DownOutlined } from "@ant-design/icons";
import { formatNum } from "@/utils/utils";

export const DataBox = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { selectedRowKeys, selectedRow, descTotal, invalidateData, loadData, setPrint, setSettleVisible, setOfferPrint, setSalePrint, detailsExport, listExport, rowsDescTotal } = useSaleRoModel();
    const { setDetailDataSource, setDetailEditForm, Settle, WhConfirm } = useSaleRoDetailModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();

    const onEdit = () => {
        if (selectedRow.status == "sale-return-status.change") {
            globalPrompt("message", { text: Locale["The document has been cancelled and cannot be edited."], type: "warning" });
            return;
        }
        if (selectedRow.status === "sale-return-status.settle") {
            globalPrompt("message", { text: Locale["The document has been settled and cannot be edited."], type: "warning" });

            return;
        }
        if (selectedRow.status === "sale-return-status.stock-io") {
            globalPrompt("message", { text: Locale["The document has been stocked out and cannot be edited."], type: "warning" });
            return;
        }
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });

            return;
        }
        let saleSoEditKey = "2-4-2";
        let isFindNav = findNav(saleSoEditKey);
        if (!isFindNav) {
            addNav(saleSoEditKey, { id: selectedRow.returnCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: Locale["Jump to the detail page of sales return doc."],
                type: "warning",
                text: Locale["The detail page of sales return doc has not been saved. Do you still want to jump?"],
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(saleSoEditKey, { id: selectedRow.returnCode as string, mode: "edit" });
                    setDetailDataSource([])
                    setDetailEditForm({})
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data to view."], type: "warning" });
            return;
        }
        let supplierEditKey = "2-4-3";
        replaceNav(
            selectedNavId,
            "2-4-3",
            { id: selectedRow.returnCode as string, mode: "look", },
            true
        );
    }
    const cancellation = async () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for cancellation."], type: "warning" });
            return;
        }
        let val: string = ""
        globalPrompt("modal", {
            title: Locale["Cancel the sales return doc."],
            type: "error",
            text: "",
            okText: Locale["Yes No"],
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    returnCode: selectedRow.returnCode
                }
                invalidateData(obj)
            },
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const onSettle = async () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        setSettleVisible(true)
    }
    const onWhConfirm = async () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let { returnCode, id } = selectedRow
        globalPrompt("modal", {
            title: Locale["Stock in the sales return doc."],
            type: "success",
            text: "",
            okText: Locale["Yes No"],
            onOk: async () => {
                let retData = await WhConfirm({ returnCode, id })
                retData ? message.success(Locale["Successfully stocked in"]) && loadData() : message.error(Locale["Unsuccessfully stocked in"])

            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }

    const onQuotationPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        setOfferPrint(true)
    }

    const onSaleBillPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        setSalePrint(true)
    }
    const MenuExport = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={listExport}>{Locale["List export"]}</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={detailsExport}>{Locale["Details export"]}</span>
                </Menu.Item>
            </Menu>
        )
    }
    const action = <>
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesReturnAdd"]}
            onClick={() => addNav("2-4-1", { id: "", mode: "add" })}
            name={Locale["Add"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesReturnEdit"]}
            onClick={onEdit}
            name={Locale["Edit"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesReturnView"]}
            onClick={onLook}
            name={Locale["View"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesReturnStockin"]}
            onClick={onWhConfirm}
            name={Locale["Stock in"]}

        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesReturnPayment"]}
            onClick={onSettle}
            name={Locale["Settle"]}
        />
        <AuthButton
            // resCode="SalesReturnCancel"
            resCode={ResourcesAuthBtn[mianCode]["SalesReturnCancel"]}
            onClick={cancellation}
            // name="作废"
            name={Locale["Cancel"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesReturnPrint"]}
            onClick={onQuotationPrint}
            name={Locale["Quotation Print"]}
        />
        <AuthButton
            resCode={ResourcesAuthBtn[mianCode]["SalesReturnPrint"]}
            onClick={onSaleBillPrint}
            name={Locale["SaleBill Print"]}
        />
        <Dropdown overlay={MenuExport}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
            >{Locale["export"]}<DownOutlined /></Button>
        </Dropdown>
    </>;
    const desc: IDescription[] = [
        {
            // label: "退货数量",
            label: Locale["Return Qty"],
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : (rowsDescTotal.totalNum),
            color: DescriptionColorEnum.red
        },
        {
            // label: "退货金额",
            label: Locale["Return Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.amount : formatNum(rowsDescTotal.amount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "应付金额",
            label: Locale["Payable Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            // label: "已付金额",
            label: Locale["Paid Amount"],
            value: selectedRowKeys.length === 0 ? descTotal.amountReceived : formatNum(rowsDescTotal.amountReceived),
            color: DescriptionColorEnum.red
        },
    ]
    return (
        <YhBox title={<></>} descriptions={desc} action={action} >
            <DataTable />
        </YhBox>
    )
}